import { ServiceTokens } from "$src/domain/ServiceTokens";
import { Folder } from "$src/domain/customers/Folder";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetFolders {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository) {}

    async execute(groupStoreId: number, customerId: number): Promise<Folder[]> {
        var folders = await this.customerRepository.getFolders(groupStoreId, customerId);

        return folders;
    }
}

export const GetFolderToken = Symbol('GetFolderToken');    

